import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import './FilterButton.css';

class FilterButton extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static propTypes = {
    isBig: PropTypes.bool.isRequired,
    rangeFilterCount: PropTypes.any.isRequired,
    filterDisabled: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
  };

  render() {
    const { isBig, rangeFilterCount, filterDisabled, onClick } = this.props;
    const { t } = this.context;
    return (
      <div>
        {isBig ? (
          <Button
            color="link"
            className={`customRangeFilterButton ${rangeFilterCount > 0 && 'customRangeAppliedFilterButton'}`}
            disabled={filterDisabled}
            onClick={onClick}>
            {t('buttons.filter')}
            {rangeFilterCount !== 0 && ` · ${rangeFilterCount}`}
          </Button>
        ) : (
          <i
            className={`togo-icon togo-icon-controls filterMobileIcon ${filterDisabled ? 'disabledIcons' : ''}`}
            onClick={() => {
              if (!filterDisabled) {
                onClick();
              }
            }}
          />
        )}
      </div>
    );
  }
}

export default FilterButton;



// WEBPACK FOOTER //
// ./src/Components/FilterButton/FilterButton.js